
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { IPersonnelActionRequest, PersonnelActionHolder } from "@tylertech/tyler-api-types";

/**
 * PersonnelActionRequestService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class PersonnelActionRequestService<T extends IPersonnelActionRequest = IPersonnelActionRequest> {
    constructor(private readonly $apiService: ApiService) { }
    
    ApprovePAR(par: T): Promise<void> {
        return this.$apiService.sendAuth("IPersonnelActionRequestService/ApprovePAR", par);
    }
    Get(filterString?: string): Promise<T[]> {
        return this.$apiService.sendAuth("IPersonnelActionRequestService/Get", null, filterString);
    }
    Initialize(id: string): Promise<PersonnelActionHolder<T>> {
        return this.$apiService.sendAuth("IPersonnelActionRequestService/Initialize", id);
    }
    Populate(initialSelection: T): Promise<PersonnelActionHolder<T>> {
        return this.$apiService.sendAuth("IPersonnelActionRequestService/Populate", initialSelection);
    }
    RejectPAR(par: T): Promise<void> {
        return this.$apiService.sendAuth("IPersonnelActionRequestService/RejectPAR", par);
    }
    Save(request: T): Promise<void> {
        return this.$apiService.sendAuth("IPersonnelActionRequestService/Save", request);
    }
}
